<template>
  <div class="pages">
    <slot></slot>
  </div>
</template>
<script>
  export default {
  	name: "appLayout",
    created(){
        if (/Android/gi.test(navigator.userAgent)) {
            const innerHeight = window.innerHeight;
            window.addEventListener('resize', () => {
                const newInnerHeight = window.innerHeight;
                if (innerHeight > newInnerHeight) {
                } else {
                    document.body.scrollTop = document.body.scrollTop
                }
            });
        } else {
            window.addEventListener('focusin', () => {
                // 键盘弹出事件处理
            });
            window.addEventListener('focusout', () => {
                document.body.scrollTop = document.body.scrollTop
                // 键盘收起事件处理
                var currentPosition, timer;
                var speed = 1;
                timer = setInterval(function () {
                    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
                    currentPosition -= speed;
                    window.scrollTo(0, currentPosition);//页面向上滚动
                    currentPosition += speed;
                    window.scrollTo(0, currentPosition);//页面向下滚动
                    clearInterval(timer);
                }, 100);
                setTimeout(function () {
                    document.body.scrollTop = document.body.scrollTop
                },500)
            });
        }
    }
  }
</script>
<style lang="scss" scoped>
  .pages{
    height: 100%;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/layouts/AppLayout/index.vue